export default "__VITE_ASSET__CFgIxCNP__"